//src/mis/components/TableSupply.jsx
import * as React from 'react';
import { Button, Box, Grid, Typography, TextField, FormControl, InputLabel, Select, MenuItem, IconButton, InputAdornment } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Search, Refresh } from '@mui/icons-material';
import {
  GridRowModes,
  DataGrid,
  GridToolbarExport, 
  GridToolbarContainer,
  GridRowEditStopReasons,
  GridCellModes,
} from '@mui/x-data-grid';

import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useState } from "react";
import 'reactjs-popup/dist/index.css';
import SupplyAdd from "../pages/SupplyAdd";
import SupplyEdit from "../pages/SupplyEdit";
import { useMediaQuery, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import env from "react-dotenv";
import moment from "moment";

import {
  createWorkbook,
  createWorksheet,
  addTitleRow,
  addSummaryRow,
  addHeaders,
  applyCellStyles,
  setColumnWidths
} from '../../utils/excelStyles'; // Adjust the path as necessary

import { saveAs } from 'file-saver'; // Ensure you have this import
import SaveAltIcon from '@mui/icons-material/SaveAlt';

const initialRows = [
  
];

// Normalize to consistent YearMonth key 'MMM-YYYY'
function normalizeYearMonth(value) {
  if (!value) return '';
  const raw = String(value).trim();
  const strictFormats = [
    'MMM-YYYY','MMM yyyy','MMM-YY','MMM YY',
    'YYYY-MM','YYYY/MM',
    'YYYY-MM-DD','YYYY/MM/DD',
    'DD-MM-YYYY','DD/MM/YYYY'
  ];
  for (const fmt of strictFormats) {
    const m = moment(raw, fmt, true);
    if (m.isValid()) return m.format('MMM-YYYY');
  }
  // Non-strict pass (case-insensitive month names etc.)
  const lenientFormats = ['MMM-YYYY','MMM YYYY','MMM-YY','MMM YY'];
  for (const fmt of lenientFormats) {
    const m = moment(raw, fmt, false);
    if (m.isValid()) return m.format('MMM-YYYY');
  }
  const mAny = moment(raw);
  if (mAny.isValid()) return mAny.format('MMM-YYYY');
  return raw;
}

// Resolve aggregate map for a row YearMonth against pivot keys (handles MMM-YYYY, YYYY-MM, and loose matches)
function resolveAggForYM(rawYm, pivot) {
  if (!rawYm || !pivot) return {};
  const ym = normalizeYearMonth(rawYm);
  const isoYm = moment(rawYm, [
    'YYYY-MM-DD','YYYY/MM/DD','YYYY-MM','YYYY/MM','MMM-YYYY','MMM YYYY','MMM-YY','MMM YY'
  ], true).isValid() ? moment(rawYm).format('YYYY-MM') : moment(ym,'MMM-YYYY').format('YYYY-MM');
  if (pivot[ym]) return pivot[ym];
  if (pivot[isoYm]) return pivot[isoYm];
  // Scan keys and match by year & month
  const target = moment(ym, 'MMM-YYYY');
  if (!target.isValid()) return {};
  let found = {};
  for (const k of Object.keys(pivot)) {
    const mk = moment(k, ['MMM-YYYY','MMM YYYY','YYYY-MM','YYYY/MM'], false);
    if (mk.isValid() && mk.year() === target.year() && mk.month() === target.month()) {
      found = pivot[k];
      break;
    }
  }
  return found || {};
}

function normalizeItemKey(s) {
  return String(s || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();
}

function resolveItemValue(agg, itemName) {
  if (!agg) return undefined;
  if (itemName in agg) return agg[itemName];
  const target = normalizeItemKey(itemName);
  for (const k of Object.keys(agg)) {
    if (normalizeItemKey(k) === target) return agg[k];
  }
  return undefined;
}

function EditToolbar(props) {
  const navigate = useNavigate();
  const { selectedCellParams, cellMode, cellModesModel, setCellModesModel, handleExport,handleAddSuccess,handleEditSuccess, data, setFilteredData, handleRefresh } = props;
  const [searchQuery, setSearchQuery] = useState('');
  const user = useSelector((state) => state.user);
  // const [isAdmin, setIsAdmin] = useState(user?.role === 'Supply Admin' ? true : false);
  const [isAdmin, setIsAdmin] = useState(() => {
    if (!user || !user.department) return false;
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    return (
      (role === 'admin' && department.includes('supply')) || 
      (role === 'super admin' && department.includes('supply'))
    );
  });

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

   const handleSearch = (query) => {
        setSearchQuery(query);
        const filtered = data.filter((row) => {
            return Object.values(row).some((field) =>
                field && field.toString().toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };
 
  const handleSaveOrEdit = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
   
    if (cellMode === 'edit') {      
    //     navigate(`../editEfficiency/${id}`, { replace: true })
        // <SupplyEdit id={id} open={open} onClose={() => setOpen(false)}/>
    } else {    
       // navigate(`../editEfficiency/${id}`, { replace: true })
        // <SupplyEdit id={id} open={open} onClose={() => setOpen(false)}/>
    }
  };



  const handleDelete = async () => {
    
    if (!selectedCellParams) {
        return;
      }
      const { id, field, dataId } = selectedCellParams;
      const rIndex = dataId;
    try {
      const res = await fetch(
        `${process.env.REACT_APP_MISBACKEND_URL}/deleteSupplyRecord/${rIndex}`,
        {
          method: "DELETE",
        }
      );
      
      navigate("../efficiencyHome/2");   
      navigate(0);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    if (!selectedCellParams) {
      return;
    }
    const { id, field } = selectedCellParams;
    setCellModesModel({
      ...cellModesModel,
      [id]: {
        ...cellModesModel[id],
        [field]: { mode: GridCellModes.View, ignoreModifications: true },
      },
    });
  };

  const handleMouseDown = (event) => {
    // Keep the focus in the cell
    event.preventDefault();
  };

  const handleClick = () => {
    // const id = randomId();
    // setRows((oldRows) => [...oldRows, { id, name: '', age: '', isNew: true }]);
    // setRowModesModel((oldModel) => ({
    //   ...oldModel,
    //   [id]: { mode: GridRowModes.Edit, fieldToFocus: 'name' },
    // }));
  };

  return (
   
    <GridToolbarContainer>
      {isAdmin && ( 
        //    <Button color="primary" startIcon={<AddIcon />} href="../efficiencyHome/add" variant="outlined">
        //    Add
        //  </Button> 
           <div>
                   <Button onClick={()=>setOpen(true)}
                    >Add
                </Button>
                <SupplyAdd open={open} onClose={() => setOpen(false)} onSuccess={handleAddSuccess}/>
            </div>
        )}
      
      {isAdmin && 
        (  
          <>
           <Button color="primary" startIcon={<EditIcon />}
          onClick={()=>{setOpenEdit(true)}}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
          >
          Edit
          </Button> 
          <SupplyEdit onSelected={selectedCellParams} open={openEdit} onClose={() => setOpenEdit(false)} onSuccess={handleEditSuccess}/> 
          </>
            
         )
        }
        {isAdmin && false && (  <Button color="primary" startIcon={<DeleteIcon />}
          onClick={handleDelete}
          onMouseDown={handleMouseDown}
          disabled={!selectedCellParams}
          variant="outlined"
        >
          {cellMode === 'edit' ? 'Delete' : 'Delete'}
        </Button>
        )}

        <Grid item>
                        <TextField
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)} // Call the search function
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <IconButton>
                                            <Search />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{ 
                            width: '1000px', // Set the desired width here
                            marginTop: "10px",                  
                            marginBottom: "10px", 
                            marginLeft: "2px",
                            marginRight: "2px",
                              backgroundColor: '#ffffff',
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#00308F',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#00207E',
                                },
                              },
                            }}
                        />
                    </Grid>

        {/* <GridToolbarExport/> */}

        <Button
        color="primary"
        onClick={handleExport}
        startIcon={<SaveAltIcon />}
        >
          Export
        </Button>    

                            <Grid item>
                              <IconButton
                                onClick={() => window.location.reload()} // Refresh the page
                                color="primary"
                                sx={{
                                  backgroundColor: '#ffffff',
                                  '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                  },
                                }}
                              >
                                <Refresh />
                              </IconButton>
                            </Grid>

    </GridToolbarContainer>
  );
}
const FullFeaturedEficiency = () => {

  const [selectedCellParams, setSelectedCellParams] = React.useState(null);
  const [cellModesModel, setCellModesModel] = React.useState({});
  const user = useSelector((state) => state.user);
  // const [isAdmin, setIsAdmin] = useState(user?.role === 'admin' ? true : false);
  const [isAdmin, setIsAdmin] = useState(() => {
    if (!user || !user.department) return false;
    const role = user.role?.toLowerCase();
    const department = user.department?.toLowerCase();
    return (
      (role === 'admin' && department.includes('supply')) || 
      (role === 'super admin' && department.includes('supply'))
    );
  });

  const [refreshTrigger, setRefreshTrigger] = React.useState(false);

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const handleCellFocus = React.useCallback((event) => {
    const row = event.currentTarget.parentElement;
    const dataId = row.dataset.id;
    const id = row.dataset.rowindex;  
    const field = event.currentTarget.dataset.field;
    setSelectedCellParams({ id, field ,dataId});
  }, []);

  const cellMode = React.useMemo(() => {
    if (!selectedCellParams) {
      return 'view';
    }
    const { id, field } = selectedCellParams;
    return cellModesModel[id]?.[field]?.mode || 'view';
  }, [cellModesModel, selectedCellParams]);

  const handleCellKeyDown = React.useCallback(
    (params, event) => {
      if (cellMode === 'edit') {
        // Prevents calling event.preventDefault() if Tab is pressed on a cell in edit mode
        event.defaultMuiPrevented = true;
      }
    },
    [cellMode],
  );

  const handleCellEditStop = React.useCallback((params, event) => {
    event.defaultMuiPrevented = true;
  }, []);


  const [searchQuery, setSearchQuery] = useState('');
  const [rows, setRows] = useState(initialRows); // Initialize with initialRows
  const [filteredData, setFilteredData] = useState(rows); // Initialize with the original rows
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [complaintItems, setComplaintItems] = React.useState([]);
  const [complaintPivot, setComplaintPivot] = React.useState({}); // { 'MMM-YYYY': { itemName: sumQty } }
  const [mainProductsSet, setMainProductsSet] = React.useState(null); // normalized allowed items
  const navigate = useNavigate();
  const location = useLocation();
  React.useEffect( () => {
    if(location.key === undefined || location.key === null || location.key === 'default'){
      navigate("/");   
    }
  }, [ location ] );  

  const handleSearch = (query) => {
        setSearchQuery(query);
        const filtered = rows.filter((row) => {
            return Object.values(row).some((field) =>
                field && field.toString().toLowerCase().includes(query.toLowerCase())
            );
        });
        setFilteredData(filtered);
    };
    const handleRefresh = () => {
        setSearchQuery('');
        getRowsFromDB(); // Call the function to fetch data from the server
    };
 
  const getRowsFromDB = async () => {
    try 
    {
      const maintenanceResponse = await fetch(`${process.env.REACT_APP_MISBACKEND_URL}/supply`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
     
      });
      const records = await maintenanceResponse.json();
     
      // setRows(Object.keys(records).map((key) => records[key])); 
      const processedData = Object.keys(records).map((key) => records[key]);
      const sortedData = processedData.sort((a, b) => {
      return new Date(b.YearMonth) - new Date(a.YearMonth); // Sort in descending order
    });
      // setRows(processedData);
      // setFilteredData(processedData); // Initialize filtered data  
       setRows(sortedData);
      setFilteredData(sortedData); // Initialize filtered data   
    
    } catch (error) {
      console.log(error);
    }
  };
  
  React.useEffect(() => {
    getRowsFromDB();
  }, [refreshTrigger]);

  React.useEffect(() => {
    getRowsFromDB();
  }, []);

  // Fetch complaints pivot (server-side) and attach as dynamic columns
  React.useEffect(() => {
    const fetchComplaints = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_MISBACKEND_URL}/complaints/pivot`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        const data = await res.json();
        setComplaintItems(Array.isArray(data?.items) ? data.items : []);
        setComplaintPivot(data?.pivot || {});
      } catch (e) {
        // ignore fetch errors; table still shows static columns
      }
    };
    fetchComplaints();
  }, []);

  // Fetch allowed items from main_product and keep as a normalized Set
  React.useEffect(() => {
    const fetchMainProducts = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_PJCBACKEND_URL}/api/main-product`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        const data = await res.json();
        const names = new Set();
        const pushName = (v) => {
          const n = normalizeItemKey(v);
          if (n) names.add(n);
        };
        if (Array.isArray(data)) {
          const candidateKeys = ['product','Product','product_name','ProductName','item','Item','item_name','ItemName','name','Name'];
          data.forEach((row) => {
            if (typeof row === 'string') {
              pushName(row);
              return;
            }
            if (!row || typeof row !== 'object') return;
            for (const key of candidateKeys) {
              const val = row[key];
              if (typeof val === 'string' && val.trim()) {
                pushName(val);
              }
            }
          });
        }
        setMainProductsSet(names);
      } catch (e) {
        setMainProductsSet(new Set());
      }
    };
    fetchMainProducts();
  }, []);

  // Keep filteredData in sync with rows and sort; do NOT enrich from complaints for supply values
  React.useEffect(() => {
    if (!rows || !rows.length) {
      setFilteredData(rows);
      return;
    }
    const sorted = [...rows].sort((a, b) => {
      const ma = moment(normalizeYearMonth(a?.YearMonth), 'MMM-YYYY');
      const mb = moment(normalizeYearMonth(b?.YearMonth), 'MMM-YYYY');
      return mb.valueOf() - ma.valueOf();
    });
    setFilteredData(sorted);
  }, [rows]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  const onRowsSelectionHandler = (ids) => {
    
    navigate(`../editEfficiency/${ids}`, { replace: true })
  };
  
  

  const handleSaveClick = (id) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => () => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row) => row.id === id);
    if (editedRow.isNew) {
      setRows(rows.filter((row) => row.id !== id));
    }
  };

  const processRowUpdate = (newRow) => {
    const updatedRow = { ...newRow, isNew: false };
    setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
    };
    const handleAddSuccess = () => {
      setRefreshTrigger(prev => !prev);
    }
  
    const handleEditSuccess = () => {
      setRefreshTrigger(prev => !prev);
      setRowSelectionModel([]);   
    }

  const handleExport = async () => {
      const workbook = createWorkbook();
      const worksheet = createWorksheet(workbook, 'Supply Data');

      addTitleRow(worksheet, 'Supply Data Report');
      addSummaryRow(worksheet, `Summary of Supply Data on ${new Date().toLocaleDateString()}`);

      const baseFieldsArr = ['ABPB','BJRL','BJTL','PBS','RPPS','RPLBS','LBS','TCEJ','RS','MEP'];
      const baseFieldsSet = new Set(baseFieldsArr);
      const dynamicNames = mainProductsSet ? Array.from(mainProductsSet).filter((n) => !baseFieldsSet.has(n)) : [];
      const excelHeaders = ['S/N', 'YearMonth', ...baseFieldsArr, ...dynamicNames];
      addHeaders(worksheet, excelHeaders);

      const sortedRows = [...rows].sort((a, b) => {
          return new Date(b.YearMonth) - new Date(a.YearMonth);
      });

      sortedRows.forEach((row, index) => {
        const baseValues = [
          row.ABPB, row.BJRL, row.BJTL, row.PBS, row.RPPS,
          row.RPLBS, row.LBS, row.TCEJ, row.RS, row.MEP
        ];
        // For export: if pivot data is available, use it as a fallback so values match the UI expectations
        const agg = resolveAggForYM(row.YearMonth, complaintPivot);
        const dynamicValues = dynamicNames.map((name) => {
          const field = name.replace(/[^a-zA-Z0-9_]/g, '_');
          if (row[field] != null) return row[field];
          if (row[name] != null) return row[name];
          const v = resolveItemValue(agg, name);
          return v ?? '';
        });
        worksheet.addRow([
          index + 1,
          row.YearMonth,
          ...baseValues,
          ...dynamicValues,
        ]);
      });

      applyCellStyles(worksheet);
      const widths = [5, 20, ...Array(excelHeaders.length - 2).fill(10)];
      setColumnWidths(worksheet, widths);

      // Ensure title (row 1) and subtitle (row 2) borders span all dynamic columns
      const totalCols = excelHeaders.length;
      const titleRow = worksheet.getRow(1);
      const subRow = worksheet.getRow(2);
      for (let c = 1; c <= totalCols; c++) {
        const tCell = titleRow.getCell(c);
        const sCell = subRow.getCell(c);
        tCell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: c === 1 ? { style: 'thin' } : undefined,
          right: c === totalCols ? { style: 'thin' } : undefined,
        };
        sCell.border = {
          top: { style: 'thin' },
          bottom: { style: 'thin' },
          left: c === 1 ? { style: 'thin' } : undefined,
          right: c === totalCols ? { style: 'thin' } : undefined,
        };
      }

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, 'SupplyData.xlsx');
  };

  const columns = React.useMemo(() => {
    const baseColumns = [
      { field: 'YearMonth', headerName: 'YearMonth', width: 120 },
      { field: 'ABPB', headerName: 'ABPB', width: 80},
      { field: 'BJRL', headerName: 'BJRL', width: 80},
      { field: 'BJTL', headerName: 'BJTL', width: 80},
      { field: 'PBS', headerName: 'PBS', width: 80},
      { field: 'RPPS', headerName: 'RPPS', width: 80},
      { field: 'RPLBS', headerName: 'RPLBS', width: 80},
      { field: 'LBS', headerName: 'LBS', width: 80},
      { field: 'TCEJ', headerName: 'TCEJ', width: 80},
      { field: 'RS', headerName: 'RS', width: 80},
      { field: 'MEP', headerName: 'MEP', width: 80},
    ];
    const baseFields = new Set(['ABPB','BJRL','BJTL','PBS','RPPS','RPLBS','LBS','TCEJ','RS','MEP']);
    const dynamicNames = mainProductsSet ? Array.from(mainProductsSet) : [];
    const dynamicCols = dynamicNames
      .filter((name) => !baseFields.has(name))
      .map((name) => {
        const field = name.replace(/[^a-zA-Z0-9_]/g, '_');
        return {
          field,
          headerName: name,
          width: 80,
          valueGetter: (params) => {
            const rawYm = params?.row?.YearMonth;
            const row = params?.row || {};
            if (row[field] != null) return row[field];
            if (row[name] != null) return row[name];
            // No fallback to complaints pivot for SUPPLY; show blank if not present
            return '';
          },
          renderCell: (params) => {
            const rawYm = params?.row?.YearMonth;
            const row = params?.row || {};
            const valDirect = row[field] ?? row[name];
            return (valDirect ?? '');
          },
        };
      });
    return [...baseColumns, ...dynamicCols];
  }, [complaintItems, mainProductsSet]);
  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
  return (
    <Box
      width={isNonMobileScreens ? "99%" : "90%"}
      sx={{
        height: 600,
        width: '95%',
        marginLeft:"180px",
        paddingRight:"90px"
      }}
    > 
      <DataGrid
        // rows={rows.slice(0).sort((a,b)=>
        //   moment(new Date(a.YearMonth)).format("YYYY-MM")
        //   .localeCompare(moment(new Date(b.YearMonth)).format("YYYY-MM"))).reverse()
        // }
        rows={filteredData} // Use filteredData here
        columns={columns}
        checkboxSelection 
        disableMultipleRowSelection
        sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            typography: 'subtitle2',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            '.MuiDataGrid-columnHeaderTitle': { 
                font: 'light important',
                overflow: 'visible !important'
             },
             '--DataGrid-overlayHeight': '300px'
          }}
        
        onCellKeyDown={handleCellKeyDown}
        cellModesModel={cellModesModel}
        onCellEditStop={handleCellEditStop}
        onCellModesModelChange={(model) => setCellModesModel(model)}
        rowSelectionModel={rowSelectionModel}
        onRowSelectionModelChange={setRowSelectionModel}
        slots={{
            toolbar: EditToolbar           
          }}
        slotProps={{
            toolbar: {
              cellMode,
              selectedCellParams,
              setSelectedCellParams,
              cellModesModel,
              setCellModesModel,
              handleExport, // Pass the export function here
              handleAddSuccess,
              handleEditSuccess,
              data: rows, // Pass the rows to the toolbar
              setFilteredData, // Pass the setter for filtered data
              handleRefresh, // Pass the refresh function
            },
            cell: {
              onFocus: handleCellFocus,
            },
        }}
        getRowId={(row) => row.id ?? row.YearMonth}
      />
    </Box>
  );
}
export default FullFeaturedEficiency;